export class TblLeadSources {
  refNo: number;
  sourceName: string;
  sourceType: string;
  sourceURL: string;
  sourceIdentifier:string
}
